import { ModuleCapabilities } from '../../Model/Module';

export enum EFetchModuleCapabilitiesAction {
  FETCH_MODULE_CAPABILITIES_PENDING = "FETCH_MODULE_CAPABILITIES_PENDING",
  FETCH_MODULE_CAPABILITIES_SUCCESS = "FETCH_MODULE_CAPABILITIES_SUCCESS",
  FETCH_MODULE_CAPABILITIES_ERROR = "FETCH_MODULE_CAPABILITIES_ERROR",
  UPDATE_MODULE_CAPABILITIES = "UPDATE_MODULE_CAPABILITIES",
}

export type FetchModuleCapabilitiesAction = {
  type: EFetchModuleCapabilitiesAction;
  moduleCapabilities?: ModuleCapabilities[],
  error?: any;
};

export function fetchModuleCapabilitiesPending(): FetchModuleCapabilitiesAction {
  return {
    type: EFetchModuleCapabilitiesAction.FETCH_MODULE_CAPABILITIES_PENDING,
  };
}

export function fetchModuleCapabilitiesSuccess(moduleCapabilities: ModuleCapabilities[]): FetchModuleCapabilitiesAction {
  return {
    type: EFetchModuleCapabilitiesAction.FETCH_MODULE_CAPABILITIES_SUCCESS,
    moduleCapabilities: moduleCapabilities,
  };
}

export function fetchModuleCapabilitiesError(error: any): FetchModuleCapabilitiesAction {
  return {
    type: EFetchModuleCapabilitiesAction.FETCH_MODULE_CAPABILITIES_ERROR,
    error: error,
  };
}


export function updateModuleCapabilities(moduleCapabilities: ModuleCapabilities[]): FetchModuleCapabilitiesAction {
  return {
    type: EFetchModuleCapabilitiesAction.UPDATE_MODULE_CAPABILITIES,
    moduleCapabilities: moduleCapabilities,
  };
}